<template>
    <div class="CAchievementBox group relative">
        <div class="flex space-x-3 sm:space-x-5">
            <div v-if="slots.icon">
                <slot name="icon" />
            </div>

            <div class="flex-auto">
                <div class="flex items-center justify-between">
                    <div v-if="slots.title" class="text-lg font-medium">
                        <slot name="title" />
                    </div>

                    <div v-if="slots.year" class="hidden whitespace-nowrap text-gray-500 dark:text-txt-body sm:block">
                        <slot name="year" />
                    </div>
                </div>

                <div v-if="slots.subtitle" class="text-sm text-gray-700 dark:text-txt-body">
                    <slot name="subtitle" />
                </div>

                <div v-if="slots.description" class="mt-3">
                    <slot name="description" />
                </div>

                <div v-if="slots.year" class="mt-1.5 block whitespace-nowrap text-[14px] text-gray-500 dark:text-txt-body sm:hidden">
                    <slot name="year" />
                </div>
            </div>
        </div>

        <div v-if="props.editable && slots.edit" class="inset-x invisible absolute group-hover:visible">
            <slot name="edit" />
        </div>
    </div>
</template>

<script setup lang="ts">
const props = defineProps<{
    editable?: boolean
}>()

const slots = useSlots()
</script>
